import type { UntitledIconData } from '../../UntitledIconData'

const ulUsers02: UntitledIconData = {
  prefix: 'ul',
  name: 'users-02',
  paths: [
    {
      shape:
        'M16 3.46776C17.4817 4.20411 18.5 5.73314 18.5 7.5C18.5 9.26686 17.4817 10.7959 16 11.5322M18 16.7664C19.5115 17.4503 20.8725 18.565 22 20M2 20C3.94649 17.5226 6.58918 16 9.5 16C12.4108 16 15.0535 17.5226 17 20M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5Z',
    },
  ],
}

export default ulUsers02
